// Libs
import classNames from 'classnames/bind';
import { Box, Tabs, TabsProps } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BaseTabList.module.scss';

type Props = TabsProps & { bordered?: boolean; group?: boolean };

const cx = classNames.bind(styles);

const BaseTabList = (props: Props) => {
  //#region Destructuring Props
  const { bordered = true, group = false, ...rest } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box
      component={'div'}
      id='baseTabListComponent'
      className={cx('container', { bordered: bordered }, { group: group })}
    >
      <Tabs {...rest}>{props.children}</Tabs>
    </Box>
  );
};

export default BaseTabList;
